import { Outlet } from 'react-router-dom';

function Cases(){
    return(
        <Outlet/>
    );
}

export default Cases;
  